module.exports = __webpack_public_path__ + "05_mid_black.2e92ea6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/05_mid_black.png
// module id = qlUm
// module chunks = 0